import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { APP_NAME } from '../../constants/app.constants';

@Component({
  selector: 'idap-auth-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent {
  protected readonly appName = APP_NAME;
}
